import { useEffect } from "react";

/** Updates the browser tab title for client-side navigation between marketing
 * pages. The server-side SeoMetaInjectionMiddleware already sets the correct
 * title/meta tags in the raw HTML for a direct page load or external link
 * click (what search engines and social-media crawlers see) - this only
 * covers the secondary case of a user navigating between marketing pages
 * without a full page reload. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => { document.title = previous; };
  }, [title]);
}
